import clsx from 'clsx'

export interface SortOption {
  id: string
  label: string
}

export interface SortBarProps {
  options: SortOption[]
  active: string
  onPick: (id: string) => void
}

export function SortBar({ options, active, onPick }: SortBarProps) {
  return (
    <div className="flex items-center justify-between gap-2">
      <span className="text-[10px] font-medium uppercase tracking-[0.12em] text-[#94A3B8]">Sort</span>
      <div className="flex gap-0.5">
        {options.map((opt) => {
          const isActive = opt.id === active
          return (
            <button
              key={opt.id}
              type="button"
              aria-pressed={isActive}
              onClick={() => onPick(opt.id)}
              className={clsx(
                'flex h-8 items-center rounded-[8px] px-2.5 text-[12px] transition-colors',
                'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#2563EB]',
                isActive
                  ? 'bg-[#EEF2F7] font-medium text-[#0F172A]'
                  : 'text-[#64748B] hover:text-[#0F172A]',
              )}
            >
              {opt.label}
            </button>
          )
        })}
      </div>
    </div>
  )
}
